// Определяем API URL в зависимости от домена
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  return hostname.includes('.local') 
    ? 'http://127.0.0.1:8000'
    : 'https://api.psypocket.mytools.quest';
};

export const API_CONFIG = {
  BASE_URL: getApiBaseUrl(),
  ENDPOINTS: {
    EMOTIONAL_STATES: '/api/emotional-states/detail',
    HOMEPAGE: '/api/homepage',
    CHAT: '/api/chat',
    COURSES: '/api/courses',
    COURSE_DETAIL: '/api/courses/:id',
    TOPIC_DETAIL: '/api/topics',
    AUDIO_PRACTICES: '/api/audio-practices',
    AUDIO_PRACTICE_DETAIL: '/api/audio-practices/:id',
    SEARCH_SUGGESTIONS: '/api/search-suggestions'
  }
};

console.log('Current hostname:', window.location.hostname);
console.log('Using API URL:', API_CONFIG.BASE_URL); 